<template>
  <v-container class="text-center pl-0 pr-0" fluid>

    <v-card v-if="countTreinos == 0 && $store.getters.userLogged.profile.professor != null">
      <v-card-text class="title">
        <v-row>
          <v-col cols="12" class="">
            <img :src="relaxImage" width="100%">
          </v-col>
          <v-col cols="12" class="">
            Você não tem treinos agendados para hoje. Aproveite o dia para relaxar ou...  <br/><br/>peça para {{$store.getters.userLogged.profile.professor.fullName}} agendar uma atividade para você.  :o)
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    
    <CardTreino v-bind:item="item" v-for="item in treinoList" :key="item.id"/>
    
    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Espera só um pouquinho...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>
//import { mdiEmoticonNeutralOutline } from '@mdi/js';

import axios from "axios";
import HOST from "../ws";
import CardTreino from '../components/CardTreino';

export default {
  //components: {
  //mdiEmoticonNeutralOutline,
  //},

  components : {
    CardTreino,
  },

  props: {
    source: String
  },
  data: () => ({

    myHost: HOST.HOST,

    dialogLoader: false,

    treinoList : [],

    countTreinos : 1,

    relaxImage : require('../assets/images/relax.jpg'),
  }),
  mounted (){

    this.dialogLoader = true;
      //carrega os treinos marcados para HOJE:
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + "/treino/meutreinododia", {}, config)
        .then(response => {
          this.treinoList = response.data;
          this.countTreinos = this.treinoList.length;
          console.log('treinos de hoje: ' + this.countTreinos);
          this.dialogLoader = false;
        })
        .catch(error => {
          this.dialogLoader = false;
          console.log(error.message);
          this.$store.commit("logout");
          this.$router.push("/");
        });
    
  },
  methods : {
    clickLike(treino){
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + "/treino/liketreino/" + treino.id, {}, config)
        .then(response => {
          treino.loveThis = !treino.loveThis;
          treino.hateThis = !treino.loveThis;
          console.log('click like : ' + response.status);  
          this.dialogLoader = false;
      })
      .catch(error => {
        console.log(error.message);
        this.dialogLoader = false;
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },
    clickHate(treino){
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + "/treino/hatetreino/" + treino.id, {}, config)
        .then(response => {
          treino.hateThis = !treino.hateThis;
          treino.loveThis = !treino.hateThis;
          console.log('click hate : ' + response.status);  
          this.dialogLoader = false;
      })
      .catch(error => {
        console.log(error.message);
        this.dialogLoader = false;
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },
  }
};
</script>